import { Card, CircularProgress, Stack, Typography } from '@mui/material';

const DashboardHighlightCard = ({
  cardPrompt,
  isLoading,
  value,
}: {
  cardPrompt: string;
  isLoading: boolean;
  value: string | number | null | undefined;
}) => {
  return (
    <Card variant="outlined">
      <Stack
        direction="column"
        justifyContent="center"
        alignItems="center"
        padding={2}
      >
        <Typography fontSize={18}>{cardPrompt}</Typography>
        <Typography fontSize={34}>
          {isLoading ? (
            <CircularProgress size={30} sx={{ color: 'primary.main' }} />
          ) : (
            value
          )}
        </Typography>
      </Stack>
    </Card>
  );
};

export default DashboardHighlightCard;
